import { Component, OnInit, ViewChild, NgZone  } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IonSlides } from '@ionic/angular';
import { Platform,AlertController } from '@ionic/angular';
import { ApiService } from '../services/api/api.service';
import { ToastService } from '../services/toast/toast.service';
import { Router } from '@angular/router';
import { File } from '@ionic-native/file/ngx';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { FCM } from '@ionic-native/fcm/ngx'
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { CallNumber } from '@ionic-native/call-number/ngx';

declare var Ionic: any
@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage implements OnInit {

  @ViewChild('slideWithNav', { static: false }) slideWithNav: IonSlides;
  appName:any = ''
  sliderOne: any;
  data: any = false
  load_products:any = true
  canScrollToLoadMore:any = false
  paginationData:any= ''
  filelocation:any = ''
  DownloadPath:any = ''
  cartCount:any = 0
  //Configuration for each Slider
  slideOptsOne = {
    initialSlide: 0,
    slidesPerView: 1,
    autoplay: true
  };

  catgList = {
    initialSlide: 0,
    slidesPerView: 1,
    autoplay: false
  };

  myCustomIcon:any = "../../assets/icon/favicon.png";
  myDiscountIcon:any = "../../assets/img/offer_bg.svg";
  from: string = ''

  vegBoxArray:any = []

  catgNameList:any = []

  catgItemList:any = []
  firstTimeLoad:any = ''
  
  selectedCategIndex:any = 0
  noCategoryResultsFound:any = false

  storeId:any = ''
  tags:any = ['Italian','Pizza']
  storeInfo:any = ''

  storeWhatsupNumber: any = ''
  storeWhatsupCountryCode: any = ''
  storeNumber:any = ''
  categoryAllId:any = 1
  constructor(
    private route: ActivatedRoute,
    public platform: Platform,
    public toast: ToastService,
    public api: ApiService,
    private router: Router,
    public zone: NgZone,
    public alertController: AlertController,
    private file: File,
    private transfer: FileTransfer,
    private sanitizer: DomSanitizer,
    private fcm: FCM,
    private callNumber: CallNumber
  ) {
    this.from = this.route.snapshot.params['from']
    this.storeId = this.route.snapshot.params['id']
    localStorage.setItem('store_id',this.storeId)

    this.api.getStoreDetailsWithId(this.storeId).subscribe(async(result:any) => {
      if(result.status == true){
        if(result.data.length > 0){
          this.storeInfo = result.data[0]
          this.appName = result.data[0].store_name
          this.storeWhatsupCountryCode = result.data[0].store_whatsapp_country_code
          this.storeWhatsupNumber = result.data[0].store_whatsapp_mobile_number
          this.storeNumber = result.data[0].store_mobile_number
        }
      }
    })

    //Item object for Nature
    this.sliderOne =
    {
      isBeginningSlide: true,
      isEndSlide: false,
      slidesItems: []
    };

  }

  deviceToken:any
 async  ngOnInit() {
    this.zone.run(async() => {
      if(this.storeId == '' || this.storeId == null || this.storeId == undefined){
        this.storeId = JSON.parse(localStorage.getItem('store_id'))
      }
      // Get the information from the API
      try {  
      await this.api.getBannerList().subscribe(async(result:any) => {
          if(result.status == true){
            if(result.data.length > 0){
                this.sliderOne.slidesItems = result.data
            }
            else {
              this.data = true
            }
            console.log(this.data,"data")
          }
          else {
            this.data = true
          }
        },(err)=>{
          this.data = true
          console.log(err)
        });
      }
      catch (error) {
        this.data = true
        console.error('Here is the error message', error);
      }

      try {
        await this.api.getVegBoxList().subscribe(async(result:any) => {
          if(result.status == true){
            if(result.data.length > 0){
                this.vegBoxArray = result.data
            }
            else {
              this.data = true
            }
            console.log(this.data,"data")
          }
          else {
            this.data = true
          }
        },(err)=>{
          this.data = true
          console.log(err)
        });
      }
      catch (error) {
        this.data = true
        console.error('Here is the error message', error);
      }

      try {
        this.api.getCategoryNameList().subscribe((result:any) => {
          if(result.status == true){
            if(result.data.length > 0){
              this.catgNameList = result.data
              this.catgNameList.forEach((element:any) => {
                if(element.category_name != "All"){
                  element.selected = false
                }
                else{
                  element.selected = true
                  this.categoryAllId = element.id
                }
              });
              this.data = true
              try {
                this.api.getAllProductsList().subscribe(async(result:any) => {
                  if(result.status == true){
                    if(result.data.length > 0){
                      this.noCategoryResultsFound = false
                      this.catgItemList = result.data
                      this.paginationData = result.links
                      if(result.links.next != null){
                        this.canScrollToLoadMore = true
                      }
                      else{
                        this.canScrollToLoadMore = false
                      }
                      this.data = true
                    }
                    else{
                      this.noCategoryResultsFound = true
                      if(result.links.next != null){
                        this.canScrollToLoadMore = true
                      }
                      else{
                        this.canScrollToLoadMore = false
                      }
                      this.data = true
                    }
                  }
                  else {
                    this.data = true
                  }
                },(err)=>{
                  this.data = true
                  console.log(err)
                });
              }
              catch (error) {
                this.data = true
                console.error('Here is the error message', error);
              }
            }
            else {
              this.data = true
            }
            console.log(this.data,"data")
          }
          else {
            this.data = true
          }
        },(err)=>{
          this.data = true
          console.log(err)
        });
      }
      catch (error) {
        this.data = true
        console.error('Here is the error message', error);
      }
    })
  }

  Gotomap(value:any){
    let destination =  JSON.stringify(JSON.parse(value.store_latitude)) + ',' + JSON.stringify(JSON.parse(value.store_longitude));
    return "http://maps.google.com/?q="+destination;
  }

  getWhatsappUrl(){
    return "https://api.whatsapp.com/send?phone="+JSON.stringify(JSON.parse(this.storeWhatsupCountryCode + this.storeWhatsupNumber))+"&amp;text=Hello!";
  }

  
  callStoreNumber(){
    this.callNumber.callNumber(this.storeNumber,true).then(res => console.log('Launched dialer!', res))
    .catch(err => console.log('Error launching dialer', err));
   }

  //Method called when slide is changed by drag or navigation
  SlideDidChange(object, slideView) {
    this.checkIfNavDisabled(object, slideView);
  }

  //Call methods to check if slide is first or last to enable disbale navigation  
  checkIfNavDisabled(object, slideView) {
    this.checkisBeginning(object, slideView);
    this.checkisEnd(object, slideView);
  }

  checkisBeginning(object, slideView) {
    slideView.isBeginning().then((istrue) => {
      object.isBeginningSlide = istrue;
    });
  }
  checkisEnd(object, slideView) {
    slideView.isEnd().then((istrue) => {
      object.isEndSlide = istrue;
    });
  }

  rstrFCMToken(){
    if(localStorage.getItem('token') != undefined && localStorage.getItem('token') != null && localStorage.getItem('token') != '' && localStorage.getItem('token') != 'null'){
      if(localStorage.getItem('fcm') != undefined && localStorage.getItem('fcm') != null && localStorage.getItem('fcm') != '' && localStorage.getItem('fcm') != 'null'){
        let requestData:any = {
          "device_token": localStorage.getItem("uuid"),
          "fcm_token": localStorage.getItem("fcm")
        }
        this.api.registerFCMToken(requestData).subscribe((result:any) => {
          console.log(result)
        },(err)=>{
          console.log(err)
        });
      }
      else{
        this.platform.ready().then(async () => {
          if (this.platform.is('hybrid')) {
            this.fcm.getToken().then(token => {
              // send this token to the server
              let fcmToken:any = token
              console.log(fcmToken)
              localStorage.setItem("fcm",fcmToken)
              if(fcmToken != null && fcmToken != 'null'){
                let requestData:any = {
                  "device_token": localStorage.getItem("uuid"),
                  "fcm_token": localStorage.getItem("fcm")
                }
                this.api.registerFCMToken(requestData).subscribe((result:any) => {
                  console.log(result)
                },(err)=>{
                  console.log(err)
                });
              }
            })
          }
        })
      }
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad HomepagePage');
    if (this.platform.width() > 1200) {
        this.catgList.slidesPerView = 4;
    }
    // On a desktop, and is wider than 768px
    else if (this.platform.width() > 768) {
        this.catgList.slidesPerView = 3;
    }
    // On a desktop, and is wider than 400px
    else if (this.platform.width() > 400) {
        this.catgList.slidesPerView = 3;
    }
    // On a desktop, and is wider than 319px
    else if (this.platform.width() > 319) {
        this.catgList.slidesPerView = 3;
    }
}

  ionViewWillEnter() {
    this.getCartCount()
    this.slideOptsOne.autoplay = true
    if(this.catgNameList.length > 0){
      for(let i = 0; i < this.catgNameList.length; i++){
        if(this.catgNameList[i].selected == true){
          this.showCategoryItems(i)
        }
      }
    }
    setTimeout(()=>{
      this.rstrFCMToken()
    },150)

  }

  goToCartPage(){
    if(localStorage.getItem('token') != undefined && localStorage.getItem('token') != null && localStorage.getItem('token') != '' && localStorage.getItem('token') != 'null'){
      this.router.navigate(['/cart'])
    }
    else{
      localStorage.setItem('previouspage',"home")
      this.router.navigate(['/login'])
    }
  }

  ionViewWillLeave(){
    this.slideOptsOne.autoplay = false
  }

  ionViewDidEnter() {
    this.slideOptsOne.autoplay = true
  }
  
  checkSearchisActive(index:any){
    this.selectedCategIndex = index
    if(this.searchTerm != ""){
      for(let i = 0; i < this.catgNameList.length; i++){
        if(i == index){
          this.catgNameList[i].selected = true
        }
        else{
          this.catgNameList[i].selected = false
        }
      }
      this.setFilteredItems()
    }
    else {
      this.showCategoryItems(index)
    }
  }

  showCategoryItems(index:any){
    this.zone.run(() => {
      this.selectedCategIndex = index
      this.load_products = false
      this.catgItemList = []
      for(let i = 0; i < this.catgNameList.length; i++){
        if(i == index){
          this.catgNameList[i].selected = true
        }
        else{
          this.catgNameList[i].selected = false
        }
      }
      if(this.catgNameList[index].id != this.categoryAllId){
        try {
          this.api.getSpecificCatgProductList(this.catgNameList[index].id).subscribe((result:any) => {
            if(result.status == true){
              if(result.data.length > 0){
                this.noCategoryResultsFound = false
                this.catgItemList = result.data
                this.paginationData = result.links
                if(result.links.next != null){
                  this.canScrollToLoadMore = true
                }
                else{
                  this.canScrollToLoadMore = false
                }
              }
              else{
                this.noCategoryResultsFound = true
                if(result.links.next != null){
                  this.canScrollToLoadMore = true
                }
                else{
                  this.canScrollToLoadMore = false
                }
              }
            }
            this.load_products = true
          },(err)=>{
            this.load_products = true
            console.log(err)
          });
        }
        catch (error) {
          this.load_products = true
          console.error('Here is the error message', error);
        }
      }
      else{
        try {
          this.api.getAllProductsList().subscribe((result:any) => {
            if(result.status == true){
              if(result.data.length > 0){
                this.catgItemList = result.data
                this.paginationData = result.links
                if(result.links.next != null){
                  this.canScrollToLoadMore = true
                }
                else{
                  this.canScrollToLoadMore = false
                }
              }
              else{
                if(result.links.next != null){
                  this.canScrollToLoadMore = true
                }
                else{
                  this.canScrollToLoadMore = false
                }
              }
            }
            this.load_products = true
          },(err)=>{
            this.load_products = true
            console.log(err)
          });
        }
        catch (error) {
          this.load_products = true
          console.error('Here is the error message', error);
        }
      }
    })
  }

  doInfinite(event:any){
    this.zone.run(() => {
      try {
        this.api.getProductsListWithPagination(this.paginationData.next).subscribe((result:any) => {
          if(result.status == true){
            if(result.data.length > 0){
              let temp:any = result.data
              this.paginationData = result.links
              for(let i = 0; i < temp.length; i++){
                this.catgItemList.push(temp[i])
              }
              if(result.links.next != null){
                this.canScrollToLoadMore = true
              }
              else{
                this.canScrollToLoadMore = false
              }
            }
          }
          event.target.complete();
        },(err)=>{
          event.target.complete();
          console.log(err)
        });
      }
      catch (error) {
        event.target.complete();
        console.error('Here is the error message', error);
      }
    })
  }

  AddToCart(value:any,index:any){
    if(localStorage.getItem('token') != undefined && localStorage.getItem('token') != null && localStorage.getItem('token') != '' && localStorage.getItem('token') != 'null'){
      this.zone.run(() => {

        this.api.isProductAlreadyInCart().subscribe((resp:any) => {
          let requestData:any = {
            "store_id": JSON.parse(localStorage.getItem("store_id")),
            "device_token": localStorage.getItem("uuid"),
            "quantity": value.products_mapping[0].items_in_cart + 1,
            "product_id": value.id,
            "price_mapping_id": value.products_mapping[0].id
            }
          if(resp.status == true){
            try {
              this.api.addProductTocart(requestData).subscribe((result:any) => {
                if(result.status == true){
                  this.catgItemList[index].products_mapping[0].items_in_cart = requestData.quantity
                  this.catgItemList[index].products_mapping[0].is_added_in_cart = true
                  let responseData:any = result.data.cart_items
                  if(responseData.cart_items.length > 0){
                    for(let i = 0;i < responseData.cart_items.length; i++){
                      if(responseData.cart_items[i].product == requestData.product_id && responseData.cart_items[i].price_mapping == requestData.price_mapping_id){
                        this.catgItemList[index].products_mapping[0].items_in_cart_details.unit_display = responseData.cart_items[i].price_details[0].unit_display
                        this.catgItemList[index].products_mapping[0].items_in_cart_details.price = responseData.cart_items[i].price_details[0].price
                        this.catgItemList[index].products_mapping[0].items_in_cart_details.discount_percentage_with_amt = responseData.cart_items[i].price_details[0].discount_percentage_with_amt
                        this.catgItemList[index].products_mapping[0].items_in_cart_details.you_save = responseData.cart_items[i].price_details[0].you_save
                        this.catgItemList[index].products_mapping[0].items_in_cart_details.discount_percentage = responseData.cart_items[i].price_details[0].discount_percentage
                      }
                    }
                  }
                  this.toast.showToast()
                  this.getCartCount()
                }
              },(err)=>{
                console.log(err)
              });
            }
            catch (error) {
              console.error('Here is the error message', error);
            }
          }
          else{
            this.discardCartItemAlert(resp.message,requestData,index)
          }
        })
      })
    }
    else{
      localStorage.setItem('previouspage',"home")
      this.router.navigate(['/login'])
    }
  }

  reduceQuantity(value:any,index:any){
    this.zone.run(() => {
    if(value.products_mapping[0].start_to_show == value.products_mapping[0].items_in_cart){

        let prodData:any = {
          "device_token": localStorage.getItem("uuid"),
          "product_id": value.id
        }
        this.api.getCartId(prodData).subscribe((result:any) => {
          if(result.status == true){
            try {
              let requestData:any = {
                "store_id": JSON.parse(localStorage.getItem("store_id")),
                "device_token": localStorage.getItem("uuid"),
                "order_id": result.data.order_id,
                "product_id": value.id,
                "cart_id": result.data.cart_id
                }
              this.api.removeProductFromCart(requestData).subscribe((result:any) => {
                if(result.status == true){
                  this.catgItemList[index].products_mapping[0].items_in_cart = 0
                  this.catgItemList[index].products_mapping[0].is_added_in_cart = false
                  this.getCartCount()
                }
              },(err)=>{
                console.log(err)
              });
            }
            catch (error) {
              console.error('Here is the error message', error);
            }
          }
        },(err)=>{
          console.log(err)
        });

    }
    else if(value.products_mapping[0].items_in_cart > value.products_mapping[0].start_to_show){
      let requestData:any = {
        "store_id": JSON.parse(localStorage.getItem("store_id")),
        "device_token": localStorage.getItem("uuid"),
        "quantity": value.products_mapping[0].items_in_cart - 1,
        "product_id": value.id,
        "price_mapping_id": value.products_mapping[0].id
        }
      try {
        this.api.addProductTocart(requestData).subscribe((result:any) => {
          if(result.status == true){
            this.catgItemList[index].products_mapping[0].items_in_cart = requestData.quantity
            let responseData:any = result.data.cart_items
            if(responseData.cart_items.length > 0){
              for(let i = 0;i < responseData.cart_items.length; i++){
                if(responseData.cart_items[i].product == requestData.product_id && responseData.cart_items[i].price_mapping == requestData.price_mapping_id){
                  this.catgItemList[index].products_mapping[0].items_in_cart_details.unit_display = responseData.cart_items[i].price_details[0].unit_display
                  this.catgItemList[index].products_mapping[0].items_in_cart_details.price = responseData.cart_items[i].price_details[0].price
                  this.catgItemList[index].products_mapping[0].items_in_cart_details.discount_percentage_with_amt = responseData.cart_items[i].price_details[0].discount_percentage_with_amt
                  this.catgItemList[index].products_mapping[0].items_in_cart_details.you_save = responseData.cart_items[i].price_details[0].you_save
                  this.catgItemList[index].products_mapping[0].items_in_cart_details.discount_percentage = responseData.cart_items[i].price_details[0].discount_percentage
                }
              }
            }
          }
        },(err)=>{
          console.log(err)
        });
      }
      catch (error) {
        console.error('Here is the error message', error);
      }
    }
  })
  }

  addQuantity(value:any,index:any){
    this.zone.run(() => {
      let requestData:any = {
        "store_id": JSON.parse(localStorage.getItem("store_id")),
        "device_token": localStorage.getItem("uuid"),
        "quantity": value.products_mapping[0].items_in_cart + 1,
        "product_id": value.id,
        "price_mapping_id": value.products_mapping[0].id
        }
      try {
        this.api.addProductTocart(requestData).subscribe((result:any) => {
          if(result.status == true){
            this.catgItemList[index].products_mapping[0].items_in_cart = requestData.quantity
            let responseData:any = result.data.cart_items
            if(responseData.cart_items.length > 0){
              for(let i = 0;i < responseData.cart_items.length; i++){
                if(responseData.cart_items[i].product == requestData.product_id && responseData.cart_items[i].price_mapping == requestData.price_mapping_id){
                  this.catgItemList[index].products_mapping[0].items_in_cart_details.unit_display = responseData.cart_items[i].price_details[0].unit_display
                  this.catgItemList[index].products_mapping[0].items_in_cart_details.price = responseData.cart_items[i].price_details[0].price
                  this.catgItemList[index].products_mapping[0].items_in_cart_details.discount_percentage_with_amt = responseData.cart_items[i].price_details[0].discount_percentage_with_amt
                  this.catgItemList[index].products_mapping[0].items_in_cart_details.you_save = responseData.cart_items[i].price_details[0].you_save
                  this.catgItemList[index].products_mapping[0].items_in_cart_details.discount_percentage = responseData.cart_items[i].price_details[0].discount_percentage
                }
              }
            }
            this.getCartCount()
          }
        },(err)=>{
          console.log(err)
        });
      }
      catch (error) {
        console.error('Here is the error message', error);
      }
    })
  }

  convertToPrice(value:any){
    return value.toFixed(2)
  }

  vegBoxAdd(value:any){
    if(localStorage.getItem('token') != undefined && localStorage.getItem('token') != null && localStorage.getItem('token') != '' && localStorage.getItem('token') != 'null'){
      this.zone.run(() => {
        let requestData:any = {
          "box": JSON.stringify(JSON.parse(value.id)),
          "device_token": localStorage.getItem("uuid")
        }
        try {
          this.api.addVegBoxTocart(requestData).subscribe((result:any) => {
            if(result.status == true){
              this.getCartCount()
              this.router.navigate(['/cart'])
            }
          },(err)=>{
            console.log(err)
          });
        }
        catch (error) {
          console.error('Here is the error message', error);
        }
      })
    }
    else{
      localStorage.setItem('previouspage',"home")
      this.router.navigate(['/login'])
    }
  }

  async doRefresh(event:any){
    this.data = false
    this.load_products = true
    this.canScrollToLoadMore = false
    this.paginationData = ''
    this.vegBoxArray = []
    this.catgNameList = []
    this.catgItemList = []
    this.firstTimeLoad = true
    localStorage.setItem("firstTimeLoad", this.firstTimeLoad)
    await this.ngOnInit()
    event.target.complete();
  }

  getCartCount(){
    if(localStorage.getItem('token') != undefined && localStorage.getItem('token') != null && localStorage.getItem('token') != '' && localStorage.getItem('token') != 'null'){
      this.zone.run(() => {
        try {
          this.api.getCartCount().subscribe((result:any) => {
            if(result.status == true){
              this.cartCount = result.data.total_cart_items
            }
          },(err)=>{
            console.log(err)
          });
        }
        catch (error) {
          console.error('Here is the error message', error);
        }
      })
    }
  }

  // async checkDirectory(fileName:any,url:any){
  //   await this.file.checkFile(this.file.cacheDirectory, fileName).then((data:any)=> console.log('File exists')).catch(async(err:any)=>{
  //     // console.log("File doesn't exist",fileName,url);
  //     await this.downloadImages(fileName,url)
  //   });
  // }
  
  // async downloadImages(fileName:any,url:any) {
  //   return new Promise((resolve, reject) => {
  //     const fileTransfer: FileTransferObject = this.transfer.create();
  //     let data = [];
  //     data.push(new Promise((resolve, reject) => {
  //     resolve( fileTransfer.download(url, this.file.cacheDirectory + fileName).then((entry) => {
  //     this.tempFileCheck = true
  //     // console.log('download complete: ' + entry.toURL());
  //     }))
  //   }))
  //     Promise.all(data).then((values) => {
  //         resolve(values)
  //     });
  //   })
  // }

  // tempFileCheck:any = false
  // openImage(img:any){
  //     let imgFileName:any = img
  //     imgFileName = imgFileName.split('/')
  //     imgFileName = imgFileName[imgFileName.length-1]
  //     return Ionic.WebView.convertFileSrc(this.file.cacheDirectory+imgFileName)
  // }

  searchTerm:any =''
  setFilteredItems(){
    console.log(this.searchTerm)
    if(this.searchTerm == "") {
      this.resetSearch()
    }
    else{
      this.load_products = false
      this.canScrollToLoadMore = false
      let reqData:any = {
        id: 0,
        search_value: this.searchTerm
      }
      for(let i = 0; i < this.catgNameList.length; i++){
        if(this.catgNameList[i].selected == true){
          reqData.id = this.catgNameList[i].id
        }
      }
  
      this.api.getSearchData(reqData).subscribe((result:any) => {
        if(result.status == true){
          this.load_products = true
          if(result.data.length > 0){
            this.noCategoryResultsFound = false
            this.catgItemList = result.data
          }
          else{
            this.noCategoryResultsFound = true
          }
        }
        },(err)=>{
          this.load_products = true
          this.noCategoryResultsFound = true
          console.log(err)
        });
    }
  }

  resetSearch(){
    this.catgNameList.forEach((element:any) => {
      if(element.category_name != "All"){
        element.selected = false
      }
      else{
        element.selected = true
      }
    });
    this.showCategoryItems(this.selectedCategIndex)
  }

  discardCartItemAlert(msg: any,reqData: any,index: any) {
    this.alertController.create({
      header: 'Replace cart item?',
      message: msg,
      backdropDismiss: false,
      buttons: [{
        text: 'No',
        role: 'cancel',
        handler: () => {
          console.log('Application exit prevented!');
        }
      }, {
        text: 'Yes',
        handler: () => {
          this.clearCartAndAddtoCart(reqData,index)
        }
      }]
    })
      .then(alert => {
        alert.present();
      });
  }

  clearCartAndAddtoCart(requestData:any,index:any){
    this.api.discardAllCartItems().subscribe((result:any) => {
        if(result.status == true){
              try {
                this.api.addProductTocart(requestData).subscribe((result:any) => {
                  if(result.status == true){
                    this.catgItemList[index].products_mapping[0].items_in_cart = requestData.quantity
                    this.catgItemList[index].products_mapping[0].is_added_in_cart = true
                    let responseData:any = result.data.cart_items
                    if(responseData.cart_items.length > 0){
                      for(let i = 0;i < responseData.cart_items.length; i++){
                        if(responseData.cart_items[i].product == requestData.product_id && responseData.cart_items[i].price_mapping == requestData.price_mapping_id){
                          this.catgItemList[index].products_mapping[0].items_in_cart_details.unit_display = responseData.cart_items[i].price_details[0].unit_display
                          this.catgItemList[index].products_mapping[0].items_in_cart_details.price = responseData.cart_items[i].price_details[0].price
                          this.catgItemList[index].products_mapping[0].items_in_cart_details.discount_percentage_with_amt = responseData.cart_items[i].price_details[0].discount_percentage_with_amt
                          this.catgItemList[index].products_mapping[0].items_in_cart_details.you_save = responseData.cart_items[i].price_details[0].you_save
                          this.catgItemList[index].products_mapping[0].items_in_cart_details.discount_percentage = responseData.cart_items[i].price_details[0].discount_percentage
                        }
                      }
                    }
                    this.toast.showToast()
                    this.getCartCount()
                  }
                },(err)=>{
                  console.log(err)
                });
              }
              catch (error) {
                console.error('Here is the error message', error);
              }
            }
          },(err)=>{
          console.log(err)
        });
    }

}
